'use client'

import React from 'react'
import { Trans } from '@lingui/react'
import { Heading, Subheading } from 'fuse_common/components/ui//heading'
import { Button } from 'fuse_common/components/ui/button'
import { Map, mapCoordinatesStore } from '@/components/map'
import { Logo } from '@/components/logo'
import { buildRootBackButtonUrl } from '@/utils/root-back-button-url'

export default function PageNotFound() {
  React.useEffect(() => {
    mapCoordinatesStore.set({
      ...mapCoordinatesStore.get(),
      showLogo: false,
      definedCoordinates: false,
      blur: true,
      showHomes: false,
      showMarker: false,
      clipRect: false,
    })
  }, [])

  return (
    <>
      <Map />
      <div className="flex flex-col justify-between h-[100dvh]">
        <div className="p-4">
          <Logo />
        </div>
        <div className="flex flex-col justify-end h-full gap-10 p-8">
          <Heading level={1}>
            <Trans id="not-found.title" />
          </Heading>
          <Subheading>
            <Trans id="not-found.message" />
          </Subheading>
          <Button appearance="primary" promo href={buildRootBackButtonUrl()}>
            <Trans id="not-found.go-home" />
          </Button>
        </div>
      </div>
    </>
  )
}
